import React, { useState } from "react";
import { MathText } from "@/components/MathText";
import { speakWordAt } from "@/lib/tts";

function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

function clueRanges(text, phrases) {
  const ranges = [];
  const lower = text.toLowerCase();
  for (const p of phrases) {
    const re = new RegExp(`\\b${esc(p)}\\b`, "g");
    let m;
    while ((m = re.exec(lower))) ranges.push([m.index, m.index + m[0].length]);
  }
  return ranges;
}

// Question text as word tokens: clue words (yellow), read-along highlight (teal) and,
// when `lang` is given, every word can be tapped to hear it on its own.
export default function QuestionText({ text, highlightPhrases = [], activeWord = null, lang = null }) {
  const [tapped, setTapped] = useState(-1);
  if (!text) return null;
  const tokens = text.split(/(\s+)/);
  const ranges = highlightPhrases.length ? clueRanges(text, highlightPhrases) : [];
  const tap = (i, n) => {
    setTapped(i);
    speakWordAt(text, n, lang);
    setTimeout(() => setTapped((t) => (t === i ? -1 : t)), 900);
  };

  let offset = 0;
  let wordNo = 0;
  return (
    <span data-testid="question-text">
      {tokens.map((tok, i) => {
        const start = offset;
        offset += tok.length;
        if (!tok.trim()) return <span key={i}>{tok}</span>;
        const n = wordNo++;
        const isClue = ranges.some(([a, b]) => start < b && start + tok.length > a);
        let cls = "rounded px-0.5 transition-colors duration-150";
        if (n === activeWord || (activeWord == null && i === tapped)) cls += " bg-teal-300";
        else if (isClue) cls += " bg-yellow-300 underline decoration-2 decoration-yellow-600";
        if (lang) cls += " cursor-pointer hover:bg-sky-100 active:bg-teal-200";
        return (
          <span key={i} className={cls} data-testid={isClue ? "clue-word" : `tap-word-${n}`}
            {...(lang ? { role: "button", tabIndex: 0, onClick: () => tap(i, n), onKeyDown: (e) => e.key === "Enter" && tap(i, n) } : {})}>
            <MathText>{tok}</MathText>
          </span>
        );
      })}
    </span>
  );
}
